import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HotkeysService, Hotkey } from 'angular2-hotkeys';
import * as $ from 'jquery';
import { AppServiceService } from './services/product.service';
import { MainMenuService } from './services/menuservice.service';
import { NgbModal, NgbModalRef, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { FooterComponent } from "../../components/footer/footer.component";

import { ColumnApi, GridApi, GridOptions, GridCell} from 'ag-grid-community';
import Swal from 'sweetalert2';
import bb from "billboard.js";

import { UtilityService } from '../shared/services/Utility.service';
import { PAGER_CONTROL_VALUE_ACCESSOR } from 'ngx-bootstrap/pagination/pager.component';
import { dispatch } from 'rxjs/internal/observable/pairs';
import { AuthService } from '../../components/auth/auth.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { from, of, Subscription } from 'rxjs';
import { CommonReportService } from '../shared/services/CommonReportService.service';
import { catchError, finalize } from 'rxjs/operators';
import { MainService } from './main.service';

/* import { ButtonRendererComponent } from './masters/cellRendererCustomNotes.component'; */

var moment = require('moment');
interface Thing {
    name: string;
    info?: string;
}

@Component({
    selector: 'main',
    template: require('./main.html'),
    providers: [FooterComponent]
    //viewProviders: [AppServiceService]
    // styles: [require('./main.css')],
})


export class MainComponent implements OnInit, AfterViewInit{
    @ViewChild('unitpopup') unitpopup: ElementRef;
    @ViewChild('DailyOutstandingInvoices') DailyOutstandingInvoices: ElementRef;
    @ViewChild('ReleaseNotePop') ReleaseNotePop: ElementRef;
    awesomeThings: Thing[] = [];
    newThing = '';
    columnDefs = [];
    edited: boolean;
    static parameters = [HttpClient, HotkeysService, Router, AppServiceService, NgbModal, FooterComponent, UtilityService, NgbModalConfig, MainMenuService, AuthService, BsDatepickerConfig, CommonReportService, MainService];
    currentInfo: any;
    modalReference: NgbModalRef;
    DailyOutstandingInvoicesReference: NgbModalRef;
    UnitSelected: any;
    itemlist: any;
    public Dispatch: any;
    public doctypelist: any;
    public dispatchdeliveryman_list: any;
    @ViewChild('todaynegativesalepopup') todaynegativesalepopup: ElementRef;
    todaynegativesaleReference: NgbModalRef;
    public gridTNSaleApi: GridApi;
    public gridTNSaleColumnApi: ColumnApi;
    public TodayNegativeSalecolumnDefs: any;
    @ViewChild('lessthanfiveGPpopup') lessthanfiveGPpopup: ElementRef;
    lessthanfivegpReference: NgbModalRef;
    public LessThanFiveGPcolumnDefs: any;
    public LessThanFiveGPDetailcolumnDefs: any;
    LessMarginCustomerProducts: any;
    @ViewChild('topGPcustomerspopup') topGPcustomerspopup: ElementRef;
    topGPcustomersReference: NgbModalRef;
    public TopGPCustomerscolumnDefs: any;
    public TopGPItemDetailcolumnDefs: any;
    @ViewChild('collectiontrackerpopup') collectiontrackerpopup: ElementRef;
    collectiontrackerReference: NgbModalRef;
    public CollectionTrackercolumnDefs: any;
    @ViewChild('overdueeinvoicepopup') overdueeinvoicepopup: ElementRef;

    @ViewChild('viewupdatetaskmodal') viewupdatetaskmodal: ElementRef;
    @ViewChild('PurchaseOrderpopup') PurchaseOrderpopup: ElementRef;

    @ViewChild('RateGroupPendingforApprovalPopup') RateGroupPendingforApprovalPopup: ElementRef;
    RateGroupReference: NgbModalRef;
    
    overdueeinvoiceReference: NgbModalRef;
    PurchaseOrdereReference: NgbModalRef;
    releaseNoteReference: NgbModalRef;
    public OverdueEinvoiceOverDaycolumnDefs: any;
    public OverdueEinvoiceDetailcolumnDefs: any;
    OverdueEinvoiceOverDayDefs: any;
    public route_list: any;
    public city_list: any;
    public area_list: any;
    public deliveryman_list: any;
    public InvoiceNo: string;
    busy: Subscription;
    hotkeyList: any = [];
    hotkeyListModal: any = [];
    public submit: string;
    private modalSubscription: Subscription;
    public searchobject: any;
    public Dispatch_List_Header: any = [];
    public Dispatch_List_HeadercolumnDefs: any = [];
    public Sales_Patch: any;
    rowSelectionSingle: any;

    InvoiceColumnHeaderList: any;
    Invoicelistdata: any;
    filterValue: any;
    multiupdaterowData: any;
    dateFormat: any; bsConfig: any;
    gridApi: GridApi;
    gridApi2: GridApi;
    gridColumnApi2: any;
    gridColumnApi: ColumnApi;
    unitInfo: any;
    rowSelectionMulti: any;
    data_details: any;
    Roll_ID: any;
    Roll_Desc: any;
    public dispatchSearch: any;
    defaultColDef: any;
    Series_List: any;
    public gridApimultiupdate: any;
    public gridColumnApimultiupdate: any;
    public updateLocationReference: NgbModalRef;
    public permissions: any;
    public controlpermission: any;
    CustomerCount: any;
    ProductCount: any;
    Sales_AreaCount: any;
    Sales_CityCount: any;
    Sales_Current_MonthCount: any;
    Sales_Six_MonthCount: any;
    Sales_StateCount: any;
    Sales_TodayCount: any;
    VendorCount: any;
    SalesOverviewGraphData: any;
    LastFivePurachesDetails: any;
    TopCompanyDetails: any;
    TopCategoryDetails: any;
    TopBrandDetails: any;
    TopProductDetails: any;
    TopPromoProductDetails: any;
    TopSalesCustomerDetails: any;
    LastExecutionTimeDetails: string = '';
    PriviousDate: any;
    To_Do_ListDetails: any;
    Mgt_MsgDetails: any;
    Sales_Loss_Today: any;
    Sales_Loss_Current_Month: any;
    public GeneralDetail: any;
    public unitInfoDetail: any;
    public searchInvoiceDate: any;
    public searchInvoiceDateLM: any;
    public Less_Than_Margin: any;
    public custDetail: any;
    public custItemDetail: any;
    public searchInvoiceDateTM: any;
    public Greater_Than_Margin: any;
    public custDetailTG: any;
    public custItemDetailTG: any;
    public CollectionTrackerDetail: any;
    public OverdueEinvoice: any;
    public OverdueEinvoiceDetail: any;
    public OverdueEinvoiceOverDay: any;
    public OverdueEinvoicedoctype: any;
    public OverdueTransType: any;
    public WarehouseStockValue: any;

    frameworkComponents: any;
    toast = Swal.mixin({
        toast: true,
        position: 'center',
        showConfirmButton: false,
        timer: 3000,
        backdrop: `rgba(30, 30, 37, 0.4)`
    });
    swalWithBootstrapButtons = Swal.mixin({
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        buttonsStyling: false,
    });

    f_check_string(p_value) {
        if (p_value == undefined || p_value === '' || p_value === null || p_value !== p_value) {
            return "";
        } else {
            return p_value;
        }
    }
    f_check_number(p_value) {
        if (p_value == undefined || p_value === '' || p_value === null || p_value !== p_value) {
            return 0;
        } else {
            return Number(p_value);
        }
    }
    constructor(private http: HttpClient, private hotkeysService: HotkeysService, private router: Router, private service: AppServiceService, private modalService: NgbModal, private _footer: FooterComponent, public utilityService: UtilityService, config: NgbModalConfig, private menuService: MainMenuService, private _AuthService: AuthService, public _bsDatepickerConfig: BsDatepickerConfig, public commonReportService: CommonReportService, private mainService: MainService) {
        //   console.log("main component");
        this.http = http;
        this.hotkeysService = hotkeysService;
        this.service = service;
        this.router = router;
        this._footer = _footer;
        this.mainService = mainService;
        this.dateFormat = JSON.parse(localStorage.getItem('permission'))[0];
        this.bsConfig = Object.assign({}, { dateInputFormat: 'DD-MMM-YYYY', containerClass: this.dateFormat.dateColorTheme });
        this._bsDatepickerConfig.dateInputFormat = 'DD-MMM-YYYY';

        this.PriviousDate = new Date();
        this.PriviousDate.setDate(this.PriviousDate.getDate() - 1);
        this.PriviousDate = moment(this.PriviousDate).format('DD-MMM-YYYY')
        this.unitInfoDetail = JSON.parse(localStorage.getItem('permission'))[0];
        this.defaultColDef = {
            resizable: true,
            sortable: true,
        };
/*         this.frameworkComponents = {
            buttonRenderer: ButtonRendererComponent,
        } */
        // this.mainuService.isUserLoggedIn.next(true);

        // this.service.getter();
        // // console.log("this.service", this.service.getter());
        // setTimeout(()=>{
        //   //   console.log("this.service.currentTable", this.service.currentTable);
        //     //console.log("this.service.currentTable", this.service.currentTable.subscribe(res=> {console.log("res", res)}));
        //     // this.service.currentTable.subscribe(res=> {
        //     //   //   console.log("response", res);
        //     //     //console.log("this.productList", this.productList);
        //     // });
        // },2000);
    }

    f_chknum(p_value) {
        var Val = Number(p_value);
        if (Val) {
            return Val;
        }
        return 0;
    }

    AUTO_REFRESH_TIME_FOR_GET_INVOICE: any;
    ALLOW_DIRECT_PRINT: any;
    SHOWWAREHOUSESTOCKVALUEONDASHBOARD: any = 0;
    ngOnInit() {
        if(this.f_check_number(this._AuthService._currentUser.isDummyPwd) == 1){
            this.router.navigate(['/changepassword']);
            return false;
        }
        this.currentInfo = {};
        this.unitList = [];
        this.radioSelected = 0;
        this.fYear = '';
        setTimeout(() => {
            this.service.getFooterDetails();
        }, 1500);
        this.rowSelectionMulti = "multiple";
        this.submit = "Save";
        this.rowSelectionSingle = "single";
        this.Dispatch = {};
        this.Dispatch.Dispatch_Date = new Date();
        this.Dispatch.From_Date = new Date();
        this.Dispatch.To_Date = new Date();
        this.Dispatch.DocType_ID = 0;
        this.Dispatch.Dispatch_Type = 'R';
        this.Dispatch.Area_ID = [];
        this.Dispatch.Deliveryman_Employee_ID = [];
        this.Sales_Patch = false;
        this.searchobject = {};
        this.searchobject.From_Date = new Date();
        this.searchobject.To_Date = new Date();
        this.Dispatch_List_Header = [];
        this.Invoicelistdata = [];
        this.permissions = {};
        this.controlpermission = {};
        //this.unitInfoDetail = JSON.parse(localStorage.getItem('permission'))[0];
         this.getUserOtherRights();
         this.getUserOtherRights2();
        /* if ("SystemConfigDetails" in localStorage) {
            var data = JSON.parse(localStorage.getItem('SystemConfigDetails'));

            var SHOWWAREHOUSESTOCKVALUEONDASHBOARD = data.filter(function (item) {
                return item.Config_Name === 'ADJUST INVOICE AGAINST SALES RETURN'
            });
            if (SHOWWAREHOUSESTOCKVALUEONDASHBOARD.length > 0) {
                this.SHOWWAREHOUSESTOCKVALUEONDASHBOARD = SHOWWAREHOUSESTOCKVALUEONDASHBOARD[0].Config_Value;
            }
        } */
        this.accordianArrowRotate();
        this.GetDashBoardData();
        this.GetDashBoardLiveData();
        this.menuService.UserPermissionmyMethodSubject.subscribe(Permission => {
            if (Permission.length == 0) {
                return false;
            }
            this.Roll_ID = Permission[0].Roll_ID;
            this.Roll_Desc = Permission[0].Roll_Desc;
            if (this.Roll_ID == 1) {
                this.Sales_Patch = true;
            } else if (this.Roll_ID == 4) {
                this.Sales_Patch = true;
            } else {
                this.Sales_Patch = false;
            }
        })
        this.getUnitData();
        this.initHotkeys();
        
        this.searchInvoiceDate = new Date();
        this.searchInvoiceDateLM = new Date();
        this.searchInvoiceDateTM = new Date();
        this.Less_Than_Margin = 9;
        this.Greater_Than_Margin = 9;

        this.OverdueEinvoicedoctype = [
            { "Doc_Type": "Sale" },
            { "Doc_Type": "SaleReturn" },
            { "Doc_Type": "BreakageExpiry" },
            { "Doc_Type": "CustomerNote" }
        ];
        this.OverdueTransType = 'Sale';
        this.SolutionHeaderDisable = true;
        this.SHOWWAREHOUSESTOCKVALUEONDASHBOARD = 0;
        
        this.modalSubscription = this.mainService.openModal$.subscribe(async (data: any) => {
            console.log("subscribe to mainService::", data);
            this.isOpenFromFooter = true;
            try {
                this.releaseNoteData = await this.GetReleasedVersionDetails(this.unitInfoDetail.ERP_Version);
                this.openReleaseNote();
            } catch (error) {
                console.log("error in openModal$", error);
            }
        });
        this.GetReleasedVersionHistory();
        setTimeout(() => {
            this.unitInfoDetail = JSON.parse(localStorage.getItem('permission'))[0];
        }, 800);
    }
    ngAfterViewInit(): void {
        console.log('inside the ngAfterViewInit');
        setTimeout(() => {

            let localStorage = JSON.parse(window.localStorage.getItem('password_policy_change'));
            console.log('🚀 ~ localStorage:', localStorage)
                if (this.f_check_number(localStorage)==1) {
                    // localStorage.removeItem('password_policy_change');
                    this.router.navigate(['/changepassword']);
                    return;
                }
        }, 250);
    }
    initHotkeys() {
        this.hotkeyList = [];
        this.hotkeyListModal = [];

        const ctrlf = new Hotkey('ctrl+f', (event: KeyboardEvent): boolean => {
            $('#Serach_Text_Box').focus().select();
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(ctrlf);
        this.hotkeysService.add(ctrlf);


        const ctrls = new Hotkey('ctrl+s', (event: KeyboardEvent): boolean => {
            event.preventDefault();
            console.log('ctrl+s from unit template');
            let $button = $('#sendOutStandingEMail');
            $button.click();
            $button.addClass("glow");
            setTimeout(() => $button.removeClass("glow"), 350);
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);

        this.hotkeyList.push(ctrls);
        this.hotkeysService.add(ctrls);

        const ctrld = new Hotkey('ctrl+d', (event: KeyboardEvent): boolean => {
            event.preventDefault();
            console.log('ctrl+d for okay');
            let $button = $('#acknoladgebtn');
            $button.click();
            $button.addClass("glow");
            setTimeout(() => $button.removeClass("glow"), 350);
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);

        this.hotkeyList.push(ctrld);
        this.hotkeysService.add(ctrld);

    }
    GetDashBoardData() {
        this.service.DashboardDatamyMethodSubject
            .subscribe((response: any) => {
                if (Object.keys(response).length == 0) {
                    return false;
                }
                let DashboardData: any = response;
                this.CustomerCount = DashboardData.HeaderListDetails[0].Customer;
                this.ProductCount = DashboardData.HeaderListDetails[0].Product;
                this.Sales_AreaCount = DashboardData.HeaderListDetails[0].Sales_Area;
                this.Sales_CityCount = DashboardData.HeaderListDetails[0].Sales_City;
                this.Sales_Current_MonthCount = DashboardData.HeaderListDetails[0].Sales_Current_Month;
                this.Sales_Six_MonthCount = DashboardData.HeaderListDetails[0].Sales_Six_Month;
                this.Sales_StateCount = DashboardData.HeaderListDetails[0].Sales_State;
                this.SalesOverviewGraphData = DashboardData.SalesOverviewGraphData;
                this.TopCompanyDetails = DashboardData.TopCompanyDetails;
                let aa = this.TopCompanyDetails;
                let bb = [];
                aa.forEach(element => {
                    let cc = [];
                    cc.push(element.Company);
                    cc.push(Number(element.Qty));
                    bb.push(cc);
                });
                this.TopCompanyDetails = JSON.stringify(bb);
                this.TopBrandDetails = DashboardData.TopBrandDetails;
                this.TopProductDetails = DashboardData.TopProductDetails;
                this.TopSalesCustomerDetails = DashboardData.TopSalesCustomerDetails;
                if(DashboardData.LastExecutionTimeDetails && DashboardData.LastExecutionTimeDetails.length > 0) {
                    this.LastExecutionTimeDetails = DashboardData.LastExecutionTimeDetails[0]["LastExecutionTime"];
                }

                setTimeout(() => {
                    this.salesOverviewMonthGraph();
                    this.topSellingCOmpanyGraph();
                    this.salesDashboardBlockHgt();
                }, 1000);
            });
    }

    GetDashBoardLiveData() {
        this.service.DashboardLiveDatamyMethodSubject
            .subscribe({
                next: (response: any) => {
                    if (Object.keys(response).length == 0) {
                        return false;
                    }
                    this.service.DashboardLiveDatamyMethodSubject.complete();
                }, complete: () => {
                    let response = this.service.DashboardLiveDatamyMethodSubject.getValue();
                    if (Object.keys(response).length == 0) {
                        return false;
                    }
                    let DashboardData: any = response;
                    this.Sales_TodayCount = DashboardData.HeaderListDetails[0].Sales_Today;
                    this.VendorCount = DashboardData.HeaderListDetails[0].Vendor;
                    this.Sales_Loss_Today = DashboardData.HeaderListDetails[0].Loss_Today;
                    this.Sales_Loss_Current_Month = DashboardData.HeaderListDetails[0].Loss_Current_Month;
                    this.LastFivePurachesDetails = DashboardData.LastFivePurachesDetails;
                    this.TopCategoryDetails = DashboardData.TopCategoryDetails;
                    this.TopPromoProductDetails = DashboardData.TopPromoProductDetails;
                    this.To_Do_ListDetails = DashboardData.To_Do_ListDetails;
                    this.Mgt_MsgDetails = DashboardData.Mgt_MsgDetails;
                    setTimeout(() => {
                        this.productPromotesList();
                        this.salesDashboardBlockHgt();
                    }, 500);
                }
            });
    }

    fYear: any;
    FyearList: any;
    unitList: any[];
    radioSelected: any;
    currentUnit: any;
    getUnitData() {
        this.service.UnitFyearDatamyMethodSubject.subscribe({
            next: (item: any) => {
                if (Object.keys(item).length == 0) {
                    return false;
                }
                this.unitList = item.UnitList;
                this.FyearList = item.FyearList;
                let xx = JSON.parse(localStorage.getItem('permission'));
                if (this.unitList.length > 0) {
                    this.service.UnitFyearDatamyMethodSubject.complete();
                    this._footer.unitInfo = xx[0];
                    this.utilityService.setPermission();
                    this.menuService.UserPermissionSetter();
                    setTimeout(() => {
                        this.service.getFooterDetails();
                    }, 500);
                }
            },
            complete: () => {
                let item: any = this.service.UnitFyearDatamyMethodSubject.getValue();
                if (Object.keys(item).length == 0) {
                    return false;
                }
                this.unitList = item.UnitList;
                this.FyearList = item.FyearList;
                let xx = JSON.parse(localStorage.getItem('permission'));
                if (xx.length > 0 && (this.f_chknum(xx[0].IsUnitChange) == 0) && this.unitList.length > 1) {
                    setTimeout(() => {
                        if (this.modalReference) {
                            this.modalReference.close();
                        }
                        this.modalReference = this.modalService.open(this.unitpopup, { size: 'sm', windowClass: 'data-show unit-show' });

                        this.modalReference.result.then((result) => {
                            console.log("result after closing unit modal", result);
                        }, (reason) => {
                            console.log("reason after closing unit modal", reason);
                            
                            this.DailyOutstandingInvoicesFn();
                            this.verifyReleaseNoteStatus();
                        });
                    }, 1000);
                }else{
                    console.log("unitList", this.unitList);
                    console.log('after unit change this case will hit');
                    setTimeout(() => {
                        this.DailyOutstandingInvoicesFn();
                        this.verifyReleaseNoteStatus();
                    }, 1000);
                }
            }
        })
    }

    getSelectedUnit(event) {
        this.unitInfo = event;
        this.service.getFooterDetails();
        this.modalReference.close();
        window.location.reload();
    }

    addThing() {
        if (this.newThing) {
            let text = this.newThing;
            this.newThing = '';
            return this.http.post('/api/things', { name: text })
                .subscribe(thing => {
                    // console.log('Added Thing:', thing);
                });
        }
    }

    changeSessionUnitInfo() {
        console.log(this.currentUnit.Unit_ID);
        return this.http.post('/api/users/changeSessionUnitInfo', { "Unit_ID": this.currentUnit.Unit_ID })
            .subscribe(thing => {
                // console.log('Added Thing:', thing);
            });
    }

    deleteThing(thing) {
        return this.http.delete(`/api/things/${thing._id}`)
            .subscribe(() => {
                // console.log('Deleted Thing');
            });
    }

    ngOnDestroy() {
        this.modalService.dismissAll();
        this.hotkeysService.remove(this.hotkeyList);
        if(this.modalSubscription){
            this.modalSubscription.unsubscribe();
        }
    }

    ////////////////////////////////////    Dashboard Data //////////////////////////

    accordianArrowRotate() {
        $('.grid_block h3').on('click', function () {
            $(this).toggleClass('rotate_arrow');
        })
    }

    salesOverviewMonthGraph() {
        /*  var chart = bb.generate({
             bindto: "#salesOverviewMonthWise",
             data: {
                 type: "bar",
                 columns: [
                     ["Sale", 300, 500, 1000, 1700, 150, 250],
                     ["Return", 150, 200, 100, 500, 150, 250]
                 ]
             }
         }); */
        //   console.log("step 2")
        //   console.log("SalesOverviewGraphData",this.SalesOverviewGraphData);
        var self = this;

        var windowHgt = $(window).height();
        var headerHgt = $('.navbar').height();
        var footerHgt = $('appfooter').height();
        var kpiheaderHGT = $('.sales_numbers').height();
        var garphContentAreaHGT = windowHgt - (headerHgt + kpiheaderHGT + footerHgt + 90);
        var gharphParentHgt = (garphContentAreaHGT / 2) - 35;

        if ($('#salesOverviewMonthWise') && $("#salesOverviewMonthWise").length > 0) {
            var chart = bb.generate({
                bindto: "#salesOverviewMonthWise",
                data: {
                    json: self.SalesOverviewGraphData,
                    type: "bar",
                    "colors": {
                        "Sale": "#17a2b8",
                        "Return": "#F95A39",
                    },
                    keys: {
                        x: "Month_Year", // it's possible to specify "x" when category axis
                        value: ["Sale","Return"],
                    }
                },

                axis: {
                    x: {
                        type: "category",
                    },
                    y: {
                        max: 100000000,
                        padding: {
                            top: 0
                        }
                    }
                },
                bar: {
                    width: {
                        ratio: 1,
                        max: 20
                    }
                },
                size: {
                    height: gharphParentHgt
                }
            });
        }
    }

    topSellingCOmpanyGraph1111() {
        //   console.log(' $("#topSellingCompany"): ', $('#topSellingCompany'));
        if (!$('#topSellingCompany') || $("#topSellingCompany").length == 0) {
            return false;
        }
        var data5 = JSON.parse(this.TopCompanyDetails)
        var chart = bb.generate({
            bindto: "#topSellingCompany",
            data: {
                columns: data5,
                type: "donut",
                onclick: function (d, i) {
                    //   console.log("onclick", d, i);
                },
                onover: function (d, i) {
                    //   console.log("onover", d, i);
                },
                onout: function (d, i) {
                    //   console.log("onout", d, i);
                },
                color: function (color, d) {
                    return ["red", "yellow", "green", "cyan", "black", "purple"][d.index];
                }
            },
            donut: {
                // title: "Iris Petal Width"
            },
        });
        chart.data.colors({
            data1: "#FFFFFF",
            data2: "#000000",
            data3: "#000000",
            data4: "#000000",
            data5: "#000000"
        });

        setTimeout(function () {
            chart.load({
                columns: data5
            });
        }, 1500);

        setTimeout(function () {
            chart.unload({
                ids: "data1"
            });
            chart.unload({
                ids: "data2"
            });
        }, 2500);
    }

    topSellingCOmpanyGraph() {
        //   console.log(' $("#topSellingCompany"): ', $('#topSellingCompany'));
        if (!$('#topSellingCompany') || $("#topSellingCompany").length == 0) {
            return false;
        }
        var data5 = JSON.parse(this.TopCompanyDetails);
        var chart = bb.generate({
            bindto: "#topSellingCompany",
            data: {
                columns: data5,
                type: "donut",
            },
            legend: {
                show: false
            },
            color: {
                pattern: ["#9564bf", "#24a221", "#ff7f00", "#1676b6", "#00a99d"]
            },
            size: {
                height: 200,
                width: 200
            },
            donut: {
                title: ""
            },
        });
    }

    topSellingItemCategory() {
        if (!$('#topSellingItem') || $("#topSellingItem").length == 0) {
            return false;
        }
        var data6 = JSON.parse(this.TopCategoryDetails)
        var chart = bb.generate({
            data: {
                columns: data6,
                type: "pie",
            },
            legend: {
                show: false
            },
            color: {
                pattern: ["#9564bf", "#24a221", "#ff7f00", "#1676b6", "#00a99d"]
            },
            size: {
                height: 200,
                width: 200
            },

            donut: {
                title: ""
            },
            bindto: "#topSellingItem",
        });
    }

    productPromotesList() {
        let promotesList = $('.promotes_area_list span');
        let currentPromotesProduct = 0;
        Rotator();
        function Rotator() {
            $(promotesList[currentPromotesProduct]).fadeIn('slow').delay(3000).fadeOut('slow');
            $(promotesList[currentPromotesProduct]).queue(function () {
                currentPromotesProduct = currentPromotesProduct < promotesList.length - 1 ? currentPromotesProduct + 1 : 0;
                Rotator();
                $(this).dequeue();
            });
        }
    }

    salesDashboardBlockHgt() {

        var windowHgt = $(window).height();
        var headerHgt = $('.navbar').height();
        var footerHgt = $('appfooter').height();
        var kpiheaderHGT = $('.sales_numbers').height();
        var garphContentAreaHGT = windowHgt - (headerHgt + kpiheaderHGT + footerHgt + 90);
        $('.dashboard_wrapper_hgt').height(windowHgt - (headerHgt + footerHgt + 45));
        $('.dashboard_right_section').height(windowHgt - (headerHgt + kpiheaderHGT + footerHgt + 95));
        /* $('.upper_grid_hgt').height((garphContentAreaHGT / 2) - 30);
        $('.lower_grid_hgt').height((garphContentAreaHGT / 2) - 30); */
        $('.upper_grid_hgt .grid_block_body').height(((garphContentAreaHGT / 2) - 30) - 5);
        $('.lower_grid_hgt .grid_block_body').height(((garphContentAreaHGT / 2) - 30) - 5);
        $('.upper_grid_hgt.hgt_with_padding .grid_block_body').height(((garphContentAreaHGT / 2) - 30) - 35);
        $('.lower_grid_hgt.hgt_with_padding .grid_block_body').height(((garphContentAreaHGT / 2) - 30) - 35);
    }
    /* General Detail*/
    findUnique(arr, predicate) {
        var found = {};
        arr.forEach(d => {
            found[predicate(d)] = d;
        });
        return Object.keys(found).map(key => found[key]);
    }
    /* Today Negative Sale */
    TodayNegativeSaleGridApi(params) {
        this.gridTNSaleApi = params.api;
        this.gridTNSaleColumnApi = params.columnApi;
        setTimeout(() => {
            this.gridTNSaleApi.sizeColumnsToFit();
        }, 100);
    }
    TodayNegativeSaleGrid(params) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        setTimeout(() => {
            this.gridApi.sizeColumnsToFit();
        }, 100);
    }
    TodayNegativeSaleGridApi1(params) {
        this.gridApi2 = params.api;
        this.gridColumnApi2 = params.columnApi;
        setTimeout(() => {
            this.gridApi2.sizeColumnsToFit();
        }, 100);
    }

    OverduegridApi: any;
    OverduegridColumnApi: any;
    OverdueEinvoiceGridApi(params) {
        this.OverduegridApi = params.api;
        this.OverduegridColumnApi = params.columnApi;
        setTimeout(() => {
            this.OverduegridApi.sizeColumnsToFit();
        }, 100);
    }

    gridLessMarginApi:any;
    gridLessMarginColumnApi:any;
    LessMarginGridApi(params){
        this.gridLessMarginApi = params.api;
        this.gridLessMarginColumnApi = params.columnApi;
    }

    gridTopMarginApi:any;
    gridTopMarginColumnApi:any;
    TopMarginGridApi(params){
        this.gridTopMarginApi = params.api;
        this.gridTopMarginColumnApi = params.columnApi;
    }

    gridCollectionApi:any;
    gridCollectionColumnApi:any;
    CollectionTrackerGridApi(params){
        this.gridCollectionApi = params.api;
        this.gridCollectionColumnApi = params.columnApi;
        setTimeout(() => {
            this.gridCollectionApi.sizeColumnsToFit();
        }, 100);
    }

    gridOverdueApi: any;
    gridOverdueColumnApi: any;
    OverdueEinvoiceOverGridApi(params){
        this.gridOverdueApi = params.api;
        this.gridOverdueColumnApi = params.columnApi;
    }

    Todaynegativebillingproducts(){
        var reqData = {
            "Company_ID": this.unitInfoDetail.Company_ID
            , "Unit_ID": this.unitInfoDetail.Unit_ID
            , "Fyear": this.unitInfoDetail.CurrentFYear
            , "Type": "TNBP"
            , "FilterDate": moment(this.searchInvoiceDate).format('YYYY-MM-DD')
        };
        this.GetDashboardGeneralDetail(reqData);
    }

    GetDashboardGeneralDetail(data) {
        this.http.post('/api/salesinvoices/Get_Dashboard_General_Detail', data)
            .subscribe(response => {
                this.GeneralDetail = response;
                //this.allItemDetail = response; 
                  //this.custDetail = this.GeneralDetail.filter((a, i) => this.GeneralDetail.findIndex((s) => a.Customer_Code === s.Customer_Code) === i);
                  this.custDetail = this.findUnique(this.GeneralDetail, d => d.Customer_ID);
                  this.custItemDetail = [];
                  this.custDetailTG = this.findUnique(this.GeneralDetail, d => d.Customer_ID);
                  this.custItemDetailTG = [];  
                  setTimeout(() => {
                    if (Number(this.gridApi.getModel().getRowCount()) > 0) {
                        this.gridApi.getModel().getRow(0).setSelected(true);
                        this.gridApi.setFocusedCell(0, "Customer_Code");
                    } 
                }, 200);
                setTimeout(() => {
                    if (Number(this.gridApi2.getModel().getRowCount()) > 0) {
                        this.gridApi2.getModel().getRow(0).setSelected(true);
                        this.gridApi2.setFocusedCell(0, "Customer_Code");
                    } 
                }, 200);

        })
    }

    onRowClicked_LessMarginCustDetail(event: any) {
       
        var selectedRows = this.gridApi.getSelectedRows();
         this.custItemDetail = this.GeneralDetail.filter(function (el) {
              return el.Customer_ID == selectedRows[0].Customer_ID;
            });
    }

    onRowClicked_TopMarginCustDetail(event: any) {
        var selectedRows = this.gridApi2.getSelectedRows();
        this.custItemDetailTG = this.GeneralDetail.filter(function (el) {
             return el.Customer_ID == selectedRows[0].Customer_ID;
           });
    }

    TodayNegativeSaleClick() { 
        if (this.modalService.hasOpenModals()) {
            this.modalService.dismissAll('close all to open new popup!');
        }
        this.todaynegativesaleReference = this.modalService.open(this.todaynegativesalepopup, { size: 'sm', windowClass: 'data-show _rightmodal fade', backdropClass: 'top96' });
        this.Todaynegativebillingproducts();
        this.TodayNegativeSalecolumnDefs = [
            { headerName: 'Product Code', field: 'Product_Code', width: 50 },
            { headerName: 'Product Name', field: 'Product_Desc', width: 100 },  
            { headerName: 'Manufacturer Name', field: 'Mfg_Code', width: 100 },  
            { headerName: 'Qty', field: 'Qty', width: 30, cellStyle: { 'text-align': 'right' } }, 
            { headerName: 'F Qty', field: 'FQty', width: 30, cellStyle: { 'text-align': 'right' } },
            { headerName: 'Batch No', field: 'Batch_No', width: 50 },
            { headerName: 'NPR', field: 'NPR', width: 40, cellStyle: { 'text-align': 'right' } },
            { headerName: 'MRP', field: 'MRP', width: 40, cellStyle: { 'text-align': 'right' } },
            { headerName: 'Billing Rate', field: 'Billing_Rate', width: 40, cellStyle: { 'text-align': 'right' } },
            { headerName: 'Margin %', field: 'Margin', width: 30, cellStyle: { 'text-align': 'right' } },
            { headerName: 'Cus. Code', field: 'Customer_Code', width: 50 },
            { headerName: 'Cus. Name', field: 'Customer_Name', width: 100 },
            { headerName: 'Invoice No', field: 'Invoice_No', width: 50 },
            { headerName: 'Invoice Date', field: 'Invoice_Date', width: 50 }
        ];
    }

    CloseTodayNegativeSalePopup() {
        this.searchInvoiceDate = new Date();
        
        this.todaynegativesaleReference.close();
    }
    /*End Today Negative Sale */

    /* Less Than 5 Percent GP*/
    LessThanFiveGPproducts(){
        var reqData = {
            "Company_ID": this.unitInfoDetail.Company_ID
            , "Unit_ID": this.unitInfoDetail.Unit_ID
            , "Fyear": this.unitInfoDetail.CurrentFYear
            , "Type": "LTPG"
            , "FilterDate": moment(this.searchInvoiceDateLM).format('YYYY-MM-DD')
            , "MarginPer": this.Less_Than_Margin
        };
        this.GetDashboardGeneralDetail(reqData);
    }

    LessThanFiveGPClick() {
        if (this.modalService.hasOpenModals()) {
            this.modalService.dismissAll('close all to open new popup!');
        }
        this.lessthanfivegpReference = this.modalService.open(this.lessthanfiveGPpopup, { size: 'sm', windowClass: 'data-show _rightmodal fade', backdropClass: 'top96' });
        this.LessThanFiveGPproducts();
        this.LessThanFiveGPcolumnDefs = [
            { headerName: 'Customer Code', field: 'Customer_Code', width: 100 },
            { headerName: 'Customer Name', field: 'Customer_Name', width: 230 } 
        ];

        this.LessThanFiveGPDetailcolumnDefs = [
            { headerName: 'Product Code', field: 'Product_Code', width: 50 },
            { headerName: 'Product Name', field: 'Product_Desc', width: 100 },  
            { headerName: 'Qty', field: 'Qty', width: 30, cellStyle: { 'text-align': 'right' } }, 
            { headerName: 'F Qty', field: 'FQty', width: 30, cellStyle: { 'text-align': 'right' } },
            { headerName: 'Batch No', field: 'Batch_No', width: 50 },
            { headerName: 'NPR', field: 'NPR', width: 40, cellStyle: { 'text-align': 'right' } },
            { headerName: 'MRP', field: 'MRP', width: 40, cellStyle: { 'text-align': 'right' } },
            { headerName: 'Billing Rate', field: 'Billing_Rate', width: 40, cellStyle: { 'text-align': 'right' } },
            { headerName: 'Margin %', field: 'Margin', width: 30, cellStyle: { 'text-align': 'right' } },
            { headerName: 'Invoice No', field: 'Invoice_No', width: 50 },
            { headerName: 'Invoice Date', field: 'Invoice_Date', width: 50 }
        ];
        this.LessMarginCustomerProducts = [
            { headerName: 'Customer Code', field: 'Customer_Code', width: 1, hide: true },
            { headerName: 'Customer Name', field: 'Customer_Name', width: 1 } ,
            { headerName: 'Product Code', field: 'Product_Code', width: 1 },
            { headerName: 'Product Name', field: 'Product_Desc', width: 1 },  
            { headerName: 'Qty', field: 'Qty', width: 1, cellStyle: { 'text-align': 'right' } }, 
            { headerName: 'F Qty', field: 'FQty', width: 1, cellStyle: { 'text-align': 'right' } },
            { headerName: 'Batch No', field: 'Batch_No', width: 1 },
            { headerName: 'NPR', field: 'NPR', width: 1, cellStyle: { 'text-align': 'right' } },
            { headerName: 'MRP', field: 'MRP', width: 40, cellStyle: { 'text-align': 'right' } },
            { headerName: 'Billing Rate', field: 'Billing_Rate', width: 1, cellStyle: { 'text-align': 'right' } },
            { headerName: 'Margin %', field: 'Margin', width: 1, cellStyle: { 'text-align': 'right' } },
            { headerName: 'Invoice No', field: 'Invoice_No', width: 1 },
            { headerName: 'Invoice Date', field: 'Invoice_Date', width: 1 }
        ]
    }

    CloseLessThanFiveGPPopup() {
        this.searchInvoiceDateLM = new Date();
        this.Less_Than_Margin = 9;
        
        this.lessthanfivegpReference.close();
    }
    /*End Less Than 5 Percent GP*/

    /* Top GP Customers*/
    TopGPCustomers(){
        var reqData = {
            "Company_ID": this.unitInfoDetail.Company_ID
            , "Unit_ID": this.unitInfoDetail.Unit_ID
            , "Fyear": this.unitInfoDetail.CurrentFYear
            , "Type": "TGC"
            , "FilterDate": moment(this.searchInvoiceDateTM).format('YYYY-MM-DD')
            , "MarginPer": this.Greater_Than_Margin
        };
        this.GetDashboardGeneralDetail(reqData);
    }

    TopGPCustomersClick() {
        if (this.modalService.hasOpenModals()) {
            this.modalService.dismissAll('close all to open new popup!');
        }
        this.topGPcustomersReference = this.modalService.open(this.topGPcustomerspopup, { size: 'sm', windowClass: 'data-show _rightmodal fade', backdropClass: 'top96' });
        this.TopGPCustomers();
        this.TopGPCustomerscolumnDefs = [
            { headerName: 'Customer Code', field: 'Customer_Code', width: 100 },
            { headerName: 'Customer Name', field: 'Customer_Name', width: 230 }
        ];

        this.TopGPItemDetailcolumnDefs = [
            { headerName: 'Product Code', field: 'Product_Code', width: 50 },
            { headerName: 'Product Name', field: 'Product_Desc', width: 100 },  
            { headerName: 'Qty', field: 'Qty', width: 30, cellStyle: { 'text-align': 'right' } }, 
            { headerName: 'F Qty', field: 'FQty', width: 30, cellStyle: { 'text-align': 'right' } },
            { headerName: 'Batch No', field: 'Batch_No', width: 50 },
            { headerName: 'NPR', field: 'NPR', width: 40, cellStyle: { 'text-align': 'right' } },
            { headerName: 'MRP', field: 'MRP', width: 40, cellStyle: { 'text-align': 'right' } },
            { headerName: 'Billing Rate', field: 'Billing_Rate', width: 40, cellStyle: { 'text-align': 'right' } },
            { headerName: 'Margin %', field: 'Margin', width: 30, cellStyle: { 'text-align': 'right' } },
            { headerName: 'Invoice No', field: 'Invoice_No', width: 50 },
            { headerName: 'Invoice Date', field: 'Invoice_Date', width: 50 }
        ];
    }

    CloseTopGPCustomersPopup() {
        this.searchInvoiceDateTM = new Date();
        this.Greater_Than_Margin = 9;

        this.topGPcustomersReference.close();
    }
    /*End Top GP Customers*/
    /*Collection Tracker*/
    CollectionTracker(){
        var reqData = {
            "Company_ID": this.unitInfoDetail.Company_ID
            , "Unit_ID": this.unitInfoDetail.Unit_ID
            , "Fyear": this.unitInfoDetail.CurrentFYear
        };
        this.GetCollectionTrackerDetail(reqData);
    }

    GetCollectionTrackerDetail(data) {
        this.http.post('/api/salesinvoices/CollectionTracker', data)
            .subscribe(response => {
                this.CollectionTrackerDetail = response;
        })
    }

    CollectionTrackerClick() {
        if (this.modalService.hasOpenModals()) {
            this.modalService.dismissAll('close all to open new popup!');
        }
        this.collectiontrackerReference = this.modalService.open(this.collectiontrackerpopup, { size: 'sm', windowClass: 'data-show _rightmodal fade', backdropClass: 'top96' });
        this.CollectionTracker();

        this.CollectionTrackercolumnDefs = [
            { headerName: 'Doc Date', field: 'Doc_Date', width: 50 },
            { headerName: 'ED Cash', field: 'EDCash', width: 50, cellStyle: { 'text-align': 'right' } },  
            { headerName: 'ED Cheque', field: 'EDCheque', width: 50, cellStyle: { 'text-align': 'right' } }, 
            { headerName: 'ED NEFT', field: 'EDNEFT', width: 50, cellStyle: { 'text-align': 'right' } },
            { headerName: 'ERP Cash', field: 'ERPCash', width: 50, cellStyle: { 'text-align': 'right' } },
            { headerName: 'ERP Chq/NEFT', field: 'ERPChqNEFT', width: 50, cellStyle: { 'text-align': 'right' } },
            { headerName: 'ERP Post Dated', field: 'ERPPostDated', width: 50, cellStyle: { 'text-align': 'right' } },
            { headerName: 'Cash Deposit In Bank', field: 'CashDepositInBank', width: 50, cellStyle: { 'text-align': 'right' } },
            { headerName: 'Reco. Amt', field: 'RecoAmt', width: 50, cellStyle: { 'text-align': 'right' } }
        ];
    }

    CloseCollectionTrackerPopup() {
        this.collectiontrackerReference.close();
    }

    /*End Collection Tracker*/
    /*Overdue E-Invoice*/
    OverdueEinvoiceDetails(){
        var reqData = {
            "Company_ID": this.unitInfoDetail.Company_ID
            , "Unit_ID": this.unitInfoDetail.Unit_ID
            , "Fyear": this.unitInfoDetail.CurrentFYear
            , "Transaction_Type": this.OverdueTransType
        };
        this.GetOverdueEinvoiceDetails(reqData);
    }

    GetOverdueEinvoiceDetails(data) {
        this.http.post('/api/salesinvoices/GetOverdueEinvoiceDetails', data)
            .subscribe(response => {
                this.OverdueEinvoice = response;

                this.OverdueEinvoiceOverDay = this.findUnique(this.OverdueEinvoice, d => d.Over_Days);
                setTimeout(() => {
                    if (Number(this.OverduegridApi.getModel().getRowCount()) > 0) {
                        this.OverduegridApi.getModel().getRow(0).setSelected(true);
                        this.OverduegridApi.setFocusedCell(0, "Over_Days");
                    } 
                }, 200);
                this.OverdueEinvoiceDetail = [];
        })
    }

    OverdueEinvoiceClick() {
        if (this.modalService.hasOpenModals()) {
            this.modalService.dismissAll('close all to open new popup!');
        }
        this.overdueeinvoiceReference = this.modalService.open(this.overdueeinvoicepopup, { size: 'sm', windowClass: 'data-show _rightmodal fade', backdropClass: 'top96' });
        this.OverdueEinvoiceDetails();

        this.OverdueEinvoiceOverDaycolumnDefs = [
            { headerName: 'Over Days', field: 'Over_Days', width: 90 },
            { headerName: 'Pending Count', field: 'Pending_Count', width: 110 }
        ];

        this.OverdueEinvoiceDetailcolumnDefs = [
            { headerName: 'Customer Code', field: 'Customer_Code', width: 100 },
            { headerName: 'Customer Name', field: 'Customer_Name', width: 200 },
            { headerName: 'Doc No.', field: 'Doc_No', width: 100 },
            { headerName: 'Doc Date', field: 'Doc_Date', width: 100 },
        ];

        this.OverdueEinvoiceOverDayDefs = [
            { headerName: 'Over Days', field: 'Over_Days', width: 90 },
            { headerName: 'Pending Count', field: 'Pending_Count', width: 110 },
            { headerName: 'Customer Code', field: 'Customer_Code', width: 100 },
            { headerName: 'Customer Name', field: 'Customer_Name', width: 200 },
            { headerName: 'Doc No.', field: 'Doc_No', width: 100 },
            { headerName: 'Doc Date', field: 'Doc_Date', width: 100 },
        ]
    }

    CloseOverdueEinvoicePopup() {
        this.OverdueTransType = 'Sale';
        this.overdueeinvoiceReference.close();
    }

    onRowClicked_OverdueEinvoiceDetail(event: any) {
        var selectedRows = this.OverduegridApi.getSelectedRows();
        this.OverdueEinvoiceDetail = this.OverdueEinvoice.filter(function (el) {
             return el.Over_Days == selectedRows[0].Over_Days;
           });
    }
    /*End Overdue E-Invoice*/
    /*End General Detail*/

    ExportExcel() {
        let d = new Date();
        var fName = 'Negative Product' + d.getTime();
        var params = {
            columnGroups: true,
            skipFooters: false,
            allColumns: true,
            fileName: fName,
        };
        this.gridTNSaleApi.exportDataAsCsv(params);
    };

    ExportExcelLess_margin() {
        let d = new Date();
        var fName = 'Less Margin' + d.getTime();
        var params = {
            columnGroups: true,
            skipFooters: false,
            allColumns: true,
            fileName: fName,
        };
        this.gridLessMarginApi.exportDataAsCsv(params);
    };


    ExportExcelTop_margin() {
        let d = new Date();
        var fName = 'Top Margin' + d.getTime();
        var params = {
            columnGroups: true,
            skipFooters: false,
            allColumns: true,
            fileName: fName,
        };
        this.gridTopMarginApi.exportDataAsCsv(params);
    };

    ExportExcelCollection(){
        let d = new Date();
        var fName = 'Collection Tracker' + d.getTime();
        var params = {
            columnGroups: true,
            skipFooters: false,
            allColumns: true,
            fileName: fName,
        };
        this.gridCollectionApi.exportDataAsCsv(params);
    };

    ExportExcelOverDues(){
        let d = new Date();
        var fName = 'OverDues' + d.getTime();
        var params = {
            columnGroups: true,
            skipFooters: false,
            allColumns: true,
            fileName: fName,
        };
        this.gridOverdueApi.exportDataAsCsv(params);
    };

    TodoDetails: any = {};
    GetTaskDetails(item){
        let mid = 'list'+item.Mid;
        this.TodoDetails= {};

        if(document.querySelector('#'+mid+':checked')){
            let data = {"ID": item.Mid, "Compnay_ID": this.unitInfoDetail.Company_ID, "Unit_ID": this.unitInfoDetail.Unit_ID};
            this.busy = this.http.post('/api/salesinvoices/GetTotoDetails', data)
            .subscribe(response => {
                this.TodoDetails = response[0];
                this.TodoDetails.Solution_Date = new Date();
                this.SolutionHeaderDisable = false;
                if (this.TodoDetails.Solution_Details) {
                    this.SolutionHeaderDisable = true;
                }
                if(this.TodoDetails){
                    this.Openupdatetaskmodal(this.viewupdatetaskmodal,mid);
                }
                
            });
        }else{
            $("#"+mid).prop("checked", false);
        }
    }

    public urls: any;
    todomodalService: NgbModalRef;
    Openupdatetaskmodal(viewupdatetaskmodal,mid) {
       this.todomodalService = this.modalService.open(viewupdatetaskmodal, { size: 'lg', windowClass: 'data-show imagemodalwidth' });
        
        this.todomodalService.result.then((e) => {
            $("#"+mid).prop("checked", false);
        }, (e) => {
            $("#"+mid).prop("checked", false);
        });
    }

    closetodopopup(){
        this.modalService.dismissAll('modal closed');
        $("#list"+this.TodoDetails.Complain_ID).prop("checked", false);
    }

    SolutionHeaderDisable: any;
    SaveComplainSolution() {

        if (!(this.TodoDetails.Solution_Details && this.TodoDetails.Solution_Details.trim().length > 0)) {
            this.toastWarningMsg("Solution is required!");
            $('#Solution_Details').focus();
            return false;
        }

        this.TodoDetails.createdBy = this.unitInfoDetail._id;
        var data = { Complain_ID: this.TodoDetails.Complain_ID, Solution_Details: this.TodoDetails.Solution_Details, Solution_Date: moment(this.TodoDetails.Solution_Date).format('YYYY-MM-DD'), createdBy: this.TodoDetails.createdBy };

        this.busy = this.http.post('/api/complainentrys/SAVE_COMPLAIN_ENTRY_SOLUTION', data)
            .subscribe(response => {
                if (response[0].flag === 1) {
                    //this.InitComplaint();
                    this.modalService.dismissAll('modal closed');
                    this.TodoDetails= {};
                    this.GetDashBoardLiveData();
                    Swal({
                        title: "Record saved successfully.",
                        type: 'success'
                    })
                }
                if (response[0].flag === 0) {
                    Swal({
                        title: response[0].msg,
                        type: 'error'
                    })
                }
            });
    }

    toastWarningMsg(msg) {
        this.toast({
            type: 'warning',
            title: msg
        });
    }

    /*Purchase Order*/


    PurchaseOrderConvertGRN: any = [];
    PurchaseOrderConvertGRNcolumnDefs: any;
    public vendorList: any;
    PurchaseOrderClick() {
        if (this.modalService.hasOpenModals()) {
            this.modalService.dismissAll('close all to open new popup!');
        }
        this.GetVendorMasterList();
        this.PurchaseOrdereReference = this.modalService.open(this.PurchaseOrderpopup, { size: 'sm', windowClass: 'data-show _rightmodal fade', backdropClass: 'top96' });
        this.PurchaseOrderDetails();
        this.PurchaseOrderConvertGRNcolumnDefs = [
            { headerName: 'Vendor Code', field: 'Vendor_Code', width: 80 },
            { headerName: 'Vendor Name', field: 'Vendor_Name', width: 200 },
            { headerName: 'PO No.', field: 'Doc_No', width: 80 },
            { headerName: 'PO Date', field: 'Doc_Date', width: 80 ,
            cellRenderer: (data) => {
                return data.value ? moment(data.value).format(this.unitInfoDetail.dateInputFormat) : '';
            }
            },
            { headerName: 'PO Amount', field: 'POAmount', width: 80, cellStyle: { 'text-align': 'right' } },
            { headerName: 'GRN No.', field: 'GRN_Doc_No', width: 200 },
            /* { headerName: 'GRN Date', field: 'GRN_Doc_Date', width: 100 }, */ 
            /* { headerName: 'GRN Amt', field: 'GRNAmount', width: 100 }, */
            /* {
                headerName: '', width: 50, cellRenderer: 'buttonRenderer'
                , cellRendererParams: {
                    onClick: this.showDetails.bind(this),
                    icon: 'fas fa-eye'
                },
            }, */
        ]
    }
    
    PurchaseOrderConvertGRNrgridApi: any;
    PurchaseOrderConvertGRNColumnApi: any;
    PurchaseOrderConvertGRNGridApi(params) {
        this.PurchaseOrderConvertGRNrgridApi = params.api;
        this.PurchaseOrderConvertGRNColumnApi = params.columnApi;
        setTimeout(() => {
            this.PurchaseOrderConvertGRNrgridApi.sizeColumnsToFit();
        }, 100);
    }

    ClosePurchaseOrderPopup() {
        this.PurchaseOrdereReference.close();
    }

    GetVendorMasterList() {
        var data = { "Unit_ID": this.unitInfoDetail.Unit_ID };
        this.busy = this.http.post('/api/vendors/GetVendorList', data)
        .subscribe(response => {
            this.vendorList = response;
        });
    }

    PurchaseOrderDetails(){
        this.PurchaseOrderConvertGRN = [];

        if (this.searchobject.From_Date > this.searchobject.To_Date) {
            this.toastWarningMsg("To date should be greater then from date.");
            return;
        }
        var From_Date = moment(this.searchobject.From_Date).format('YYYY-MM-DD');
        var To_Date = moment(this.searchobject.To_Date).format('YYYY-MM-DD');

        let data = {
            Vendor_ID: this.f_chknum(this.searchobject.Vendor_ID),
            From_Date: From_Date,
            To_Date: To_Date,
            Company_ID: this.unitInfoDetail.Company_ID,
            Unit_ID: this.unitInfoDetail.Unit_ID,
            FYear: this.unitInfoDetail.CurrentFYear
        };
        this.busy = this.http.post('/api/purchaseorders/GetPurchaseOrderList_Dashboard', data)
        .subscribe(response => {
            this.PurchaseOrderConvertGRN = response;
            setTimeout(() => {
                if (this.PurchaseOrderConvertGRN.length > 0) {
                    this.PurchaseOrderConvertGRNrgridApi.getModel().getRow(0).setSelected(true);
                    setTimeout(() => {
                        this.PurchaseOrderConvertGRNrgridApi.setFocusedCell(0, "Doc_No");
                    }, 500);
                    this.Total_Row_Count();                 
                } else {
                    $('#Vendor_Name input[role=combobox]').focus().select();
                    this.Total_Row_Count();
                }
            }, 300);
        });
    }

    TotaPO:any = 0;
    TotaGRNPO:any = 0;
    TotaPendingPO:any = 0;
    Total_Row_Count(){
        let parent = this;
        var TotalRowData_2 = { "Vendor_Code": 'Total PO: ',  "Vendor_Name": this.PurchaseOrderConvertGRN.length, "POAmount": 0, "GRNAmount": 0};

        TotalRowData_2.POAmount = (this.PurchaseOrderConvertGRN.reduce(function (acc, sum) {
            return acc + parent.f_chknum(sum.POAmount);
        }, 0));
        
        TotalRowData_2.GRNAmount = (this.PurchaseOrderConvertGRN.reduce(function (acc, sum) {
            return acc + parent.f_chknum(sum.GRNAmount);
        }, 0));

        setTimeout(() => {
            this.PurchaseOrderConvertGRNrgridApi.setPinnedBottomRowData([TotalRowData_2]);
            this.TotaPO = this.PurchaseOrderConvertGRN.length;
            let TotaGRNPO = this.PurchaseOrderConvertGRN.filter(function (item) {
                return parent.f_check_string(item.GRN_Doc_No) != ''
            });
            this.TotaGRNPO = TotaGRNPO.length;
            this.TotaPendingPO = this.f_chknum(this.TotaPO) - this.f_chknum(this.TotaGRNPO);
        }, 200);
    }

    clearSearchPO(){
        this.searchobject.Vendor_ID = 0;
        this.searchobject.From_Date = new Date();
        this.searchobject.To_Date = new Date();
        this.PurchaseOrderDetails();
    }

    onSerachTextBoxFilterChanged() {
        let value = $('input#Serach_Text_Box').val();
        this.PurchaseOrderConvertGRNrgridApi.setQuickFilter(value);
    }
    /*End Purchase Order*/
    /* PO Count Start */

    POCountClick() {
        if (this.modalService.hasOpenModals()) {
            this.modalService.dismissAll('close all to open new popup!');
        }
        this.overdueeinvoiceReference = this.modalService.open(this.overdueeinvoicepopup, { size: 'sm', windowClass: 'data-show _rightmodal fade', backdropClass: 'top96' });
        this.OverdueEinvoiceDetails();

        this.OverdueEinvoiceOverDaycolumnDefs = [
            { headerName: 'Over Days', field: 'Over_Days', width: 90 },
            { headerName: 'Pending Count', field: 'Pending_Count', width: 110 }
        ];

        this.OverdueEinvoiceDetailcolumnDefs = [
            { headerName: 'Customer Code', field: 'Customer_Code', width: 100 },
            { headerName: 'Customer Name', field: 'Customer_Name', width: 200 },
            { headerName: 'Doc No.', field: 'Doc_No', width: 100 },
            { headerName: 'Doc Date', field: 'Doc_Date', width: 100 },
        ];

        this.OverdueEinvoiceOverDayDefs = [
            { headerName: 'Over Days', field: 'Over_Days', width: 90 },
            { headerName: 'Pending Count', field: 'Pending_Count', width: 110 },
            { headerName: 'Customer Code', field: 'Customer_Code', width: 100 },
            { headerName: 'Customer Name', field: 'Customer_Name', width: 200 },
            { headerName: 'Doc No.', field: 'Doc_No', width: 100 },
            { headerName: 'Doc Date', field: 'Doc_Date', width: 100 },
        ]
    }

    /* PO Count End */
    UserOtherRights:any;
    getUserOtherRights() {
        this.UserOtherRights = {};
        var data = { "UserID": this.unitInfoDetail._id, "ScreenCode": 'H01' };
        this.utilityService.getUserOtherRights(data).subscribe(result => {
            var Res: any = result;
            Res.forEach(element => {
                this.UserOtherRights[element["RIGHTS_NAME"]] = 1;
            });

            this.SHOWWAREHOUSESTOCKVALUEONDASHBOARD = this.f_chknum(this.UserOtherRights ? this.UserOtherRights["SHOW_WAREHOUSE_STOCK_VALUE_ON_DASHBOARD"] : 0);

            this.dailyOutstandingPopup_enabled = this.f_chknum(this.UserOtherRights ? this.UserOtherRights["SHOW_DAILY_OUTSTANDING_INVOICE_POPUP"] : 0);
            // other rights to send email permission
            this.allowSendOutstandingEmail = this.f_chknum(this.UserOtherRights ? this.UserOtherRights["ALLOW_SEND_OUTSTANDING_EMAIL"] : 0);
        });
    }

    UserOtherRights2:any;
    Allow_Approve_Rate_Details:any = 0;
    getUserOtherRights2() {
        this.UserOtherRights2 = {};
        let data2 = { "UserID": this.unitInfoDetail._id, "ScreenCode": 'GM10', "Unit_ID": this.unitInfoDetail.Unit_ID };
        this.utilityService.getUserOtherRights(data2).subscribe(result => {
            let Res2: any = result;
            Res2.forEach(element => {
                this.UserOtherRights2[element["RIGHTS_NAME"]] = 1;
            });
            this.Allow_Approve_Rate_Details = this.f_check_number(this.UserOtherRights2 ? this.UserOtherRights2["Allow_Approve_Rate_Details"] : 0);
        });
    }
    ClickWarehouseStockValue(){
        // alert('hi');
        // this.WarehouseStockValue =[];

        this.busy = this.http.get('/api/users/Get_Warehouse_Stock_Value_For_Dashboard/' + this.unitInfoDetail.Unit_ID)
        .subscribe((result:any) => {
            this.WarehouseStockValue =result;
        });
    }

    formatToIndianNumber(value: number | string): string {
        if (value == null) return '';
        let numberString = value.toString();
        let lastThreeDigits = numberString.slice(-3);
        let remainingDigits = numberString.slice(0, -3);
      
        if (remainingDigits) {
          lastThreeDigits = ',' + lastThreeDigits;
        }
      
        return remainingDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThreeDigits;
      }     

    DailyOutsandingInvoicesColumnDefs = [
        { headerName: 'Cust. Code', field: 'Customer_Code', width: 80 },
        { headerName: 'Cust. Name', field: 'Customer_Name', width: 180 },
        { headerName: 'Cust. Email', field: 'Customer_EmailID', width: 180, cellStyle: { 'text-align': 'left' } },
        { headerName: 'Cust. Disc.', field: 'Cust_Discount', width: 70, cellStyle: { 'text-align': 'right' }, },
        { headerName: 'Credit Days', field: 'CreditDays', width: 70, cellStyle: { 'text-align': 'right' }, },
        { headerName: 'Credit Limit', field: 'CreditLimit', width: 80, cellStyle: { 'text-align': 'right' }, },
        { headerName: 'Invoice No', field: 'Invoice_No', width: 100, cellStyle: { 'text-align': 'center' }, },
        { headerName: 'Invoice Date', field: 'Invoice_Date', width: 100, cellStyle: { 'text-align': 'center' }, },
        { headerName: 'Invoice Amt', field: 'Invoice_Amount', width: 100, cellStyle: { 'text-align': 'right' } },
        { headerName: 'Area', field: 'Cust_Area', width: 100, cellStyle: { 'text-align': 'right' } },
        { headerName: 'Route', field: 'Cust_Route', width: 120, cellStyle: { 'text-align': 'right' } },
        { headerName: 'Salesman', field: 'Cust_Salesman', width: 120, cellStyle: { 'text-align': 'right' } },
        {
            headerName: 'Send Mail', field: 'Email_Sent', width: 120, headerCheckboxSelection: false, 
            checkboxSelection: params => this.isRowSelectable(params.data), pinned: 'right',
            cellStyle: { 'text-align': 'center' }, cellRenderer: (data) => {
                if (this.f_check_string(data.data.Customer_EmailID) == '') {
                    return '<span style="font-size:10px; padding:0; margin:0; color: #ff474c">Email ID Not Found</span>';
                }else if(this.f_chknum(data.data.Email_Sent) == 1){
                    return '<span style="font-size:10px; padding:0; margin:0; color: #00A300">Already Sent</span>';
                }else{
                    return '';
                }
            }
        },
        { headerName: 'Sent By', field: 'UserName', width: 120 },
        {
            headerName: 'Email On', field: 'EmailOn', width: 120, cellRenderer: (params) => {
                if (params.data.EmailOn) {
                    return moment(params.data.EmailOn).format('YYYY-MM-DD hh:mm A');
                }else{
                    return '';
                }
            }
        },
        { headerName: 'Email Error', field: 'EmailError', width: 200 },
    ];

    isRowSelectable(rowNode) {
        const data = rowNode;
        return !!data.Customer_EmailID && this.f_chknum(data.Email_Sent) != 1;
    }

    DailyInvoiceData: any = [];
    DailyInvoiceDataOriginal: any = [];
    dailyOutstandingPopup_enabled: any = 0; 
    allowSendOutstandingEmail: any = 0; 
    // Dropdown Data
    uniqueAreas: string[] = [];
    uniqueRoutes: string[] = [];
    uniqueSalesmen: string[] = [];
    selectedArea = null ;
    selectedRoute =null;
    selectedSalesman =null;
    filterbyArray: any[] = [
        { value: 'All', label: 'All' },
        { value: 'withEmail', label: 'With Email' },
        { value: 'withoutEmail', label: 'Without Email' }
    ];
    selectedFilterBy = 'All';
    async DailyOutstandingInvoicesFn(isManualClick: boolean = false) {
        if(this.dailyOutstandingPopup_enabled == 0){
            console.log('🚀 ~ this.dailyOutstandingPopup_enabled:', this.dailyOutstandingPopup_enabled);
            return false;
        }
        if (this.modalService.hasOpenModals()) {
            this.modalService.dismissAll('close all to open new popup!');
        }

        try {
            let status = await  this.checkOutstandingUserstampEntry();
            console.log('🚀 ~ status:', status)
            if(status == true && isManualClick == false){
                console.log('Userstamp Entry already exists!');
                return false;
            }
            this.DailyInvoiceDataOriginal = await this.getDailyOutstandingInvoices();
            this.DailyInvoiceData = [...this.DailyInvoiceDataOriginal]; 
            this.uniqueAreas = Array.from(new Set(this.DailyInvoiceDataOriginal.map((item) => item.Cust_Area).filter(x=>x)));
            // console.log('🚀 ~ this.uniqueAreas:', this.uniqueAreas)
            this.uniqueRoutes = Array.from(new Set(this.DailyInvoiceDataOriginal.map((item) => item.Cust_Route).filter(x=>x)));
            // console.log('🚀 ~ this.uniqueRoutes:', this.uniqueRoutes)
            this.uniqueSalesmen = Array.from(new Set(this.DailyInvoiceDataOriginal.map((item) => item.Cust_Salesman).filter(x=>x)));
            // console.log('🚀 ~ this.uniqueSalesmen:', this.uniqueSalesmen)

            if (this.DailyInvoiceData.length > 0) {
                // Open the Model Popup
                this.DailyOutstandingInvoicesReference = this.modalService.open(this.DailyOutstandingInvoices, { size: 'sm', windowClass: 'data-show width-90 height-400', centered: true, });
                
                this.DailyOutstandingInvoicesReference.result.then((result) => {
                    console.log('🚀 ~ result:', result);
                    this.InsertOutstandingUserStamp();
                }, (reason) => {
                    console.log('🚀 ~ reason:', reason);
                    this.InsertOutstandingUserStamp();
                });

                setTimeout(() => {
                    this.gridDailyOTApi.setFocusedCell(0, "Customer_Code");
                    this.gridDailyOTApi.getModel().getRow(0).setSelected(false);
                    // this.gridDailyOTColumnApi.getAllColumns().forEach((column) => {
                    //     this.gridDailyOTColumnApi.autoSizeColumn(column.getColId());
                    // });
                }, 100);
            
            } else {
                console.log('No Outstanding invoices found for this user!');
            }
        } catch (error) {
            console.log('🚀 ~ error:', error)            
        }
    }

    async getDailyOutstandingInvoices(): Promise<any> {
        let data = {
            Company_ID: this.unitInfoDetail.Company_ID,
            Unit_ID: this.unitInfoDetail.Unit_ID,
            Fyear: this.unitInfoDetail.CurrentFYear,
            User_ID: this.f_check_number(this.unitInfoDetail.Group_ID) == 1 ? null: this.unitInfoDetail._id,
            // "Fyear": this.selectedFYear
        };
        return new Promise((resolve, reject) => {
            this.busy = this.http.post('/api/units/GetAutoCustomerOutstandingEmail', data)
                .subscribe((response: any[]) => {
                    resolve(response);
                });
        });
    }

    defaultColDefOT = {
        resizable: true,
        sortable: true,
    }
    rowSelectionMultiple = "multiple";
    overlayNoRowsTemplate = "<span class='ag-overlay-loading-center'>No Data Available</span>";

    gridDailyOTApi: GridApi;
    gridDailyOTColumnApi: ColumnApi;
    DailyOutstandingInvoicesGridApi(params) {
        this.gridDailyOTApi = params.api;
        this.gridDailyOTColumnApi = params.columnApi;
        setTimeout(() => {
            $('.ag-center-cols-viewport').css('overflow-x', 'inherit');
            $('.ag-theme-balham .ag-root').css('border-radius', '3px');
            // this.gridDailyOTApi.sizeColumnsToFit();
        }, 100);
    }

    sendOutStandingEMail() {
        let selectedRows = this.gridDailyOTApi.getSelectedRows().filter(row=> this.isRowSelectable(row)).map(row => row);
        console.log('🚀 ~ selectedRows:', selectedRows)
        
        if (selectedRows.length == 0) {
            this.toastWarningMsg("Please select the row checkbox to send email!");
            return false;
        }
        let successCount = 0;
        let failureCount = 0;
        const emailPromises = selectedRows.map((row) => {
            var dataEmail = {
                Company_ID: this.unitInfoDetail.Company_ID,
                Unit_ID: this.unitInfoDetail.Unit_ID,
                Fyear: this.unitInfoDetail.CurrentFYear,
                Department: 'GENERAL',
                Email: row.Customer_EmailID,
                Subject: `Overdue Payment Reminder`,
                Invoice_No: row.Invoice_No,
                Customer_Name: row.Customer_Name,
                TotalBillAmount: row.Invoice_Amount,
                User_ID: this.unitInfoDetail._id,
                FI_ID: row.FI_ID,
                Customer_ID: row.Customer_ID,
            };

            return this.http.post('/api/units/SendOutstandingEmailtoCustomers', dataEmail).toPromise()
                .then(response => {
                    if (response["error_code"] == 0) {
                        successCount++;
                    } else {
                        failureCount++;
                    }
                })
                .catch(error => {
                    failureCount++;
                });
        });

        this.busy = from(Promise.all(emailPromises)).subscribe(() => {
            // this.toastWarningMsg(`Emails sent successfully: ${successCount}, Failed: ${failureCount}`);
            Swal({
                title: `Emails sent successfully: ${successCount}, Failed: ${failureCount}`,
                type: 'success',  
            }).then((rs) => {
                console.log('🚀 ~ rs:', rs)
            });
            this.gridDailyOTApi.deselectAll();
            setTimeout(async () => {
                try {
                    this.DailyInvoiceDataOriginal = await this.getDailyOutstandingInvoices();
                    this.DailyInvoiceData = [...this.DailyInvoiceDataOriginal];
                } catch (error) {
                    console.log('🚀 ~ error:', error)
                    
                }
            }, 150);
        });
    }


    async checkOutstandingUserstampEntry() {
        let data = {
            Company_ID: this.unitInfoDetail.Company_ID,
            Unit_ID: this.unitInfoDetail.Unit_ID,
            Fyear: this.unitInfoDetail.CurrentFYear,
            User_ID: this.unitInfoDetail._id,
        }
        let result = await Promise.all([new Promise((resolve, reject) => {
            this.busy = this.http.post('/api/units/GetOutstandingUserstamp', data)
                .subscribe((res: any) => {
                    if (res.length > 0 && this.f_chknum(res[0]["IsAttended"]) == 1) {
                        resolve(1);
                    }else{
                        resolve(0);
                    }
                }, (error) => {
                    resolve(0)
                })
        })]);
        if (result.length > 0) {
            return result[0] == 1;
        } else {
            return true;
        }
    }

    InsertOutstandingUserStamp() {
        let data = {
            Company_ID: this.unitInfoDetail.Company_ID,
            Unit_ID: this.unitInfoDetail.Unit_ID,
            Fyear: this.unitInfoDetail.CurrentFYear,
            User_ID: this.unitInfoDetail._id,
        }
        this.busy = this.http.post('/api/units/InsertOutstandingUserStamp', data)
            .pipe(
                catchError((error) => {
                    console.log('🚀 ~ error in InsertOutstandingUserStamp:', error)
                    return of([]);
                }),
                finalize(() => {
                  console.log('🚀 ~ InsertOutstandingUserStamp ~ finalize ~ InsertOutstandingUserStamp');
                })
            )
            .subscribe((res: any) => {
                console.log('🚀 ~ res:', res)
            });
    }

    releaseNoteData: any[] = [];     
    releaseNoteColumnDefs = [
        { headerName: 'Sr. No', field: 'SrNo', width: 40,  cellStyle: { 'text-align': 'right' }},
        { headerName: 'Issue Key', field: 'Issue_Key', width: 60 },
        { headerName: 'Issue Type', field: 'Issue_Type', width: 80, },
        { headerName: 'Summary', field: 'Summary', width: 450,  autoHeight: true,cellStyle: { 'white-space': 'normal', 'text-transform':'none' },},
    ];
    releaseGridApi: GridApi;
    releaseGridColumnApi: ColumnApi;
    ReleaseNotePopGridApi(params) {
        this.releaseGridApi = params.api;
        this.releaseGridColumnApi = params.columnApi;
        $('.ag-center-cols-viewport').css('overflow-x', 'inherit');
        setTimeout(() => {
            this.releaseGridApi.sizeColumnsToFit();
        }, 100);
    }

    defaultColDefReleaseNote = {
        resizable: true,
        sortable: true,
    }

    async verifyReleaseNoteStatus(){
        // check the status if the user has already seen the release note or not
        
        let status = await this.GetVersionUserstamp();
        if(status == true){
            console.log('version userstamp already exists!');
            return false;
        }
        // this.mainService.
        this.releaseNoteData = await this.GetReleasedVersionDetails('');
        
        if(this.releaseNoteData.length > 0){
            // console.log('🚀 ~ this.releaseNoteData:', this.releaseNoteData);
            this.openReleaseNote();
        }
    }
    openReleaseNote(){
        this.releaseNoteReference = this.modalService.open(this.ReleaseNotePop, { size: 'lg', windowClass: 'data-show width-80 height-400', centered: true, keyboard:true, backdrop:'static',  });
        this.ReleaseNotePopGridApi({
            api: this.releaseGridApi,
            columnApi: this.releaseGridColumnApi
        });
        setTimeout(() => {
            this.releaseGridApi.setRowData(this.releaseNoteData);
            // this.gridColumnApi.autoSizeColumn('Summary');
            // this.releaseGridApi.getModel().getRow(0).setSelected(true);
            // this.releaseGridApi.setFocusedCell(0, "Issue_Key");
            $('#acknoladgebtn').focus().select();
        }, 100);

        this.releaseNoteReference.result.then((result) => {
            // console.log('🚀 ~ result:', result);
            this.InsertVersionUserStamp();
        }, (reason) => {
            // console.log('🚀 ~ reason:', reason);
            this.InsertVersionUserStamp();
        });
    }

    GetReleasedVersionDetails(version: string = ''): Promise<any>  {
        let requestPayload={
            Version: version==''? this.unitInfoDetail.ERP_Version: version,
        };
        return new Promise<any[]>((resolve, reject) => {
            this.busy = this.http.post('/api/units/GetReleasedVersionDetails', requestPayload)
                .subscribe((response: any[]) => {
                    this.selectedVersionDetails = response[0] || { 'Version': '', 'Release_Date': '' };
                    resolve(response);
                });
        })
    }

    async GetVersionUserstamp() {
        // console.log(" this.unitInfoDetail", this.unitInfoDetail);
        this.selecteVersionNo = this.unitInfoDetail.ERP_Version;
        let data = { 
            "User_ID": this.unitInfoDetail._id, 
            "Version": this.unitInfoDetail.ERP_Version, 
        };
        let result = await Promise.all([new Promise((resolve, reject) => {
            this.busy = this.http.post('/api/units/GetVersionUserstamp', data)
                .subscribe((res: any) => {
                    if (res.length > 0 && this.f_chknum(res[0]["IsAttended"]) == 1) {
                        resolve(1);
                    }else{
                        resolve(0);
                    }
                }, (error) => {
                    resolve(0)
                })
        })]);
        if (result.length > 0) {
            return result[0] == 1;
        } else {
            return true;
        }
    }
    isOpenFromFooter: boolean = false;
    InsertVersionUserStamp() {
        if(this.isOpenFromFooter == true){
            // console.log('do nothing');
            return false;
        }
        let data = { 
            "User_ID": this.unitInfoDetail._id, 
            "Version": this.selecteVersionNo, 
        };
        this.busy = this.http.post('/api/units/InsertVersionUserStamp', data)
            .pipe(
                catchError((error) => {
                    // console.log('🚀 ~ error in InsertVersionUserStamp:', error)
                    return of([]);
                }),
                finalize(() => {
                //   console.log('🚀 ~ InsertVersionUserStamp ~ finalize ~ InsertVersionUserStamp');
                })
            )
            .subscribe((res: any) => {
                // console.log('🚀 ~ res:', res)
            });
    }

    OkClicked(){
        this.releaseNoteReference.close();
    }

    selectedVersionDetails: any = {
        isLatest: true,
        Version: '',
        Release_Date: '',
    };
    selecteVersionNo: any = '';
    releaseVersionHistory: any[] = [];
    GetReleasedVersionHistory(){
        this.busy = this.http.post('/api/units/GetReleasedVersionHistory',{})
        .subscribe((response: any[]) => {
            // console.log('🚀 ~ response:', response);
            this.releaseVersionHistory = response;
            if(this.releaseVersionHistory.length > 0){
                // this.selectedVersionDetails = this.releaseVersionHistory[0];
                // this.selecteVersionNo = this.selectedVersionDetails.Version;
            }
        });
    }

    async onVersionChange(event){
        // console.log('🚀 ~ event:', event);
        this.selecteVersionNo = event.Version; 
        this.selectedVersionDetails = Object.assign({}, event);
        this.releaseNoteData = await this.GetReleasedVersionDetails(this.selecteVersionNo);
        this.releaseGridApi.setFocusedCell(0, "Issue_Key");
    }

    searchTextDOInvoices: string = '';
    onSearchChangeDailyOutstandingInvoices(event) {
        console.log('🚀 ~ event:', event);
        this.gridDailyOTApi.setQuickFilter(this.searchTextDOInvoices);
    }
    selectedFilter: string = 'all';
    applyEmailFilter() {
        try {
            let filteredArray = [...this.DailyInvoiceDataOriginal];
            let self = this;
            if(this.selectedFilter == 'withEmail'){
                filteredArray = filteredArray.filter(item => self.f_check_string(item.Customer_EmailID) != '');
            }else if (this.selectedFilter == 'withoutEmail') {
                filteredArray = filteredArray.filter(item => self.f_check_string(item.Customer_EmailID) == '');
            }else{
                filteredArray = [...this.DailyInvoiceDataOriginal];
            }
    
            this.DailyInvoiceData = filteredArray;
            this.gridDailyOTApi.setRowData(this.DailyInvoiceData);
        } catch (error) {
            console.log('🚀 ~ error:', error)
            
        }
      }
    isSelectedAllOT: boolean = false;
    toggleSelectAllOTInvoices() {
        try {
            // console.log('🚀 ~ this.gridDailyOTApi:', this.gridDailyOTApi);
            this.isSelectedAllOT = !this.isSelectedAllOT;
            let self = this;
            if (this.isSelectedAllOT) {
                // this.DailyInvoiceData.forEach(item => {
                //     if (self.f_check_string(item.Customer_EmailID) != '' && self.f_check_number(item.Email_Sent) == 0) {
                //         // this.gridDailyOTApi.selectIndex(this.DailyInvoiceData.indexOf(item), false, true).
                //         self.gridDailyOTApi.getModel().getRow(self.DailyInvoiceData.indexOf(item)).setSelected(true);
                //     }
                // });
                let selectedNodes: any[] = [];
                this.gridDailyOTApi.forEachNode(node =>{
                    if (self.f_check_string(node.data.Customer_EmailID) != '' && self.f_check_number(node.data.Email_Sent) == 0) {
                        node.setSelected(true);
                        selectedNodes.push(node);
                    }
                });
                 // Flash selected rows after selection
                this.gridDailyOTApi.flashCells({
                    rowNodes: selectedNodes,
                    columns: ["Email_Sent"],
                });
            } else {
                this.gridDailyOTApi.deselectAll();
            }
        } catch (error) {
            console.log('🚀 ~ error:', error)
            
        }
    }

    ExportDailyOutstandingInvoices(){
        if(this.DailyInvoiceData.length > 0){
            let params= {
                fileName: 'DailyOTInvoices',
                allColumns: true,

            };
            this.gridDailyOTApi.exportDataAsCsv(params);
        }
    }

    applyFilters() {
        try {
            this.DailyInvoiceData = [...this.DailyInvoiceDataOriginal.filter((item) => {
                return ( 
                    (this.selectedFilterBy == 'All' ? true : true) &&
                    (this.selectedFilterBy == 'withEmail' ? this.f_check_string(item.Customer_EmailID) != '' : true) &&
                    (this.selectedFilterBy == 'withoutEmail' ? this.f_check_string(item.Customer_EmailID) == '' : true) &&
                    (this.selectedArea ? item.Cust_Area == this.selectedArea : true) &&
                    (this.selectedRoute ? item.Cust_Route == this.selectedRoute : true) &&
                    (this.selectedSalesman ? item.Cust_Salesman == this.selectedSalesman : true)
                );
            })];
        } catch (error) {
            console.log('🚀 ~ error:', error)
        }
    }
    resetFilters() {
        this.selectedArea = null;
        this.selectedRoute = null;
        this.selectedSalesman = null;
        this.selectedFilterBy = 'All';
        this.DailyInvoiceData = [...this.DailyInvoiceDataOriginal];
    }

    closeRategroup(){
        if(this.RateGroupReference) this.RateGroupReference.close();
    }
    RateGroupPendingApprovalData: any = [];
    RateGroupPendingApprovalColumnDefs: any = [
        { headerName: 'Rate Group Code', field: 'RateGroup_Code', width: 150 },
        { headerName: 'Rate Group Desc.', field: 'RateGroup_Desc', width: 250 },
        { headerName: 'Pending Items', field: 'Pending_Items', width: 120, cellStyle: { 'text-align': 'right' } },
        { headerName: 'Created By', field: 'CreatedBy', width: 150 },
        { headerName: 'Created On', field: 'CreatedOn', width: 150 },
        { headerName: 'Modified By', field: 'ModifiedBy', width: 150 },
        { headerName: 'Modified On', field: 'ModifiedOn', width: 150 },
        { headerName: 'View', field: '', pinned:'right', width: 50, cellRenderer: (data) => {
            if (data) {
                let btn = document.createElement('button');
                btn.className = 'btn btn-sm btn-primary';
                btn.innerHTML = '<i class="fa fa-eye"></i>';
                btn.addEventListener('click', () => {
                    this.viewRateGroupDetails(data.data);
                });
                return btn;
            } else {
                return '';
            }
            }
        },
    ];

    gridRateGroupApi: GridApi;
    gridRateGroupColumnApi: ColumnApi;
    RateGroupPendingApprovalGridApi(params){
        this.gridRateGroupApi = params.api;
        this.gridRateGroupColumnApi = params.columnApi;
        setTimeout(() => {
            this.gridRateGroupApi.sizeColumnsToFit();
        }, 100);
    }

    async openRateGroupPendingApprovalPopup(){
        if (this.modalService.hasOpenModals()) {
            this.modalService.dismissAll('close all to open new popup!');
        }
        this.RateGroupReference = this.modalService.open(this.RateGroupPendingforApprovalPopup, { size: 'sm', windowClass: 'data-show _rightmodal fade PurchaseExp', backdropClass: 'top96' });

        try {
            this.RateGroupPendingDetails = [];
            this.RateGroupPendingApprovalData = await this.getRateGroupPendingApprovalList();
        } catch (error) {
            console.log('🚀 ~ error:', error)
            this.RateGroupPendingApprovalData = [];
        }
    }

    getRateGroupPendingApprovalList(): Promise<any> {
        let data = {
            Company_ID: this.unitInfoDetail.Company_ID,
            Unit_ID: this.unitInfoDetail.Unit_ID,
            Fyear: this.unitInfoDetail.CurrentFYear,
        };
        return new Promise<any[]>((resolve, reject) => {
            this.busy = this.http.post(`/api/${this.unitInfoDetail.Company_Code}/products/Get_Pending_RateGroupList`, data)
                .subscribe((response: any[]) => {
                    resolve(response);
                });
        });
        
    }

    async viewRateGroupDetails(data){
        let result =  await this.getRateGroupListDetails(data);
        this.RateGroupPendingDetails = result;
    }

    RateGroupPendingDetails: any[] = [];
    RateGroupPendingDetailsColumnDefs: any = [
        { headerName: 'Product Code', field: 'Product_Code', width: 120 },
        { headerName: 'Product Name', field: 'Product_Desc', width: 200 },
        { headerName: 'Pack Size', field: 'Packsize', width: 100 },
        // { headerName: 'Manufacturer', field: 'Manufacturer_Name', width: 200 },
        { headerName: 'MRP', field: 'MRP', width: 100 },
        { headerName: 'Rate', field: 'Rate', width: 100 },
        { headerName: 'Qty', field: 'Qty', width: 70 },
        { headerName: 'Free Qty', field: 'Free_Qty', width: 100 },
        { headerName: 'Disc Calc On', field: 'SpecialRate_Name', width: 120 },
        { headerName: 'Disc %', field: 'DiscountPercent', width: 80 },
        { headerName: 'Sch %', field: 'SchemePercent', width: 80 },
        { headerName: 'Cust. PTS', field: 'C_PTS', width: 80 },
        { headerName: 'Cust. Margin%', field: 'C_Margin', width: 80 },
        { headerName: 'From Date', field: 'From_Date', width: 100 },
        { headerName: 'To Date', field: 'To_Date', width: 100 },
        { headerName: 'Remarks', field: 'Remarks', width: 250 },
        {
            headerName: 'Created On', field: 'CreatedOn', width: 120, cellRenderer: function (params) {
                if (params) {
                    return params.value ? moment(params.value).format('DD-MMM-YYYY hh:mm A') : '';
                } else {
                    return '';
                }
            }
        },
        { headerName: 'Modified By', field: 'ModifiedBy', width: 120 },
        {
            headerName: 'Modified On', field: 'ModifiedOn', width: 120, cellRenderer: function (params) {
                if (params) {
                    return params.value ? moment(params.value).format('DD-MMM-YYYY hh:mm A') : '';
                } else {
                    return '';
                }
            }
        },
    ];

    gridRateGroupDetailsApi: GridApi;
    gridRateGroupDetailsColumnApi: ColumnApi;
    RateGroupDetailsGridApi(params){
        this.gridRateGroupDetailsApi = params.api;
        this.gridRateGroupDetailsColumnApi = params.columnApi;
    }

    async getRateGroupListDetails(inputObj): Promise<any> {
        let data = {
            Company_ID: this.unitInfoDetail.Company_ID,
            Unit_ID: this.unitInfoDetail.Unit_ID,
            Fyear: this.unitInfoDetail.CurrentFYear,
            RateGroup_ID: inputObj.RateGroup_ID,
        };
        return new Promise<any[]>((resolve, reject) => {
            this.busy = this.http.post(`/api/${this.unitInfoDetail.Company_Code}/products/Get_Pending_RateGroupList`, data)
                .subscribe((response: any[]) => {
                    resolve(response);
                });
        });
    }
}
